import gamesLoader from './gamesLoader';
export default gamesLoader;
